import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

// ========== GET EMPLOYEE LEAVE BALANCE SERVICE ==========
export const getEmployeeLeaveBalance = async (data: any) => {
	const URL = `${API_URL}GetEmployeeLeaveBalance`;
	const requestData = {
		GetEmployeeLeaveBalanceToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== CREATE LEAVE ADJUSTMENT SERVICE ==========
export const createLeaveAdjustment = async (data: any) => {
	const URL = `${API_URL}CreateLeaveAdjustment`;
	const requestData = {
		CreateLeaveAdjustmentToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== GET EMPLOYEE APPROVED LEAVES FOR YEAR ==========
export const getEmployeeApprovedLeavesForYear = async (data: any) => {
	const URL = `${API_URL}GetEmployeeApprovedLeavesForYear`;
	const requestData = {
		GetEmployeeApprovedLeavesForYearToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== UPDATE APPLIED LEAVE ==========
export const updateAppliedLeave = async (data: any) => {
	const URL = `${API_URL}UpdateAppliedLeave`;
	const requestData = {
		UpdateAppliedLeaveToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== GET LEAVE EDIT HISTORY ==========
export const getLeaveEditHistory = async (data: any) => {
	const URL = `${API_URL}GetLeaveEditHistory`;
	const requestData = {
		GetLeaveEditHistoryToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== GET LEAVE ADJUSTMENT HISTORY ==========
export const getLeaveAdjustmentHistory = async (data: any) => {
	const URL = `${API_URL}GetEmployeeLeaveAdjustmentHistory`;
	const requestData = {
		GetEmployeeLeaveAdjustmentHistoryToken: data,
	};
	return makeApiCall(URL, requestData);
};

